import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['expandCollapseBtn', 'expandCollapseIcon', 'expandCollapseLabel']

  connect() {
    this.allExpanded = false
  }

  toggleExpandCollapse(event) {
    event.preventDefault()

    // Toggle the state
    this.allExpanded = !this.allExpanded

    // Find all turbo-collapse controllers within this scope
    const collapseElements = this.element.querySelectorAll('[data-controller*="turbo-collapse"]')

    collapseElements.forEach(element => {
      const controller = this.application.getControllerForElementAndIdentifier(element, 'turbo-collapse')
      if (controller && controller.hasContentTarget) {
        controller.toggleDetails(this.allExpanded)

        // Update localStorage for each item
        if (controller.hasNameTarget) {
          window.localStorage.setItem(controller.nameTarget.dataset.name, this.allExpanded)
        }
      }
    })

    // Update button text and icon
    this.updateButtonState()
  }

  updateButtonState() {
    if (this.hasExpandCollapseLabelTarget) {
      this.expandCollapseLabelTarget.textContent = this.allExpanded ? 'Collapse all' : 'Expand all'
    }

    if (this.hasExpandCollapseIconTarget) {
      if (this.allExpanded) {
        this.expandCollapseIconTarget.style.transform = 'rotate(90deg)'
      } else {
        this.expandCollapseIconTarget.style.transform = ''
      }
    }
  }
}
